import React,
{
  forwardRef,
  ForwardRefExoticComponent,
  RefAttributes,
  useState,
} from 'react';
import { ControllerFieldState, ControllerRenderProps } from 'react-hook-form/dist/types/controller';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import { getFinalErrorMessage } from 'lib/form/FormUtils';
import PhoneInput from 'react-phone-number-input';
import PhoneInputWithoutFlag from 'react-phone-number-input/input';

import { TextField } from '@material-ui/core';
import { UseFormStateReturn } from 'react-hook-form/dist/types';

type Props = {
  disabled?: boolean
  control: {
    field: ControllerRenderProps<any, any>,
    fieldState: ControllerFieldState,
    formState: UseFormStateReturn<any>,
  },
  label?: string
  error: FieldErrors,
  apiErrors?: { [key: string]: string[] },
  flag?: boolean
};

// @ts-ignore
export default function PhoneNumberInputWrapper(
  {
    disabled,
    control,
    label,
    error,
    apiErrors,
    flag,
  }: Props,
) {
  const { field } = control;
  const [ForwardInputComponent] = useState<ForwardRefExoticComponent<RefAttributes<any>>>(
    forwardRef((props: any, ref) => (
      <div className="material-textfield-wrapper">
        <TextField
          {...props}
          error={!!props.error}
          helperText={props.error}
          fullWidth
          disabled={disabled}
          label={label || undefined}
          variant="filled"
          inputRef={ref}
          InputProps={{
            disableUnderline: true,
          }}
        />
      </div>
    )),
  );

  const FinalPhoneInput = flag ? PhoneInput : PhoneInputWithoutFlag;
  const errorMessage = getFinalErrorMessage(field.name, error, apiErrors);

  return (
    <FinalPhoneInput
      {...field}
      disabled={disabled}
      error={errorMessage}
      defaultCountry="FR"
      // @ts-ignore
      inputComponent={ForwardInputComponent}
    />
  );
}
